export const localstoragekey = 'blogger/records/search_keys'
export const noHandleArray = ['search', 'handle']